// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.0
//   protoc               v5.28.0
// source: access_check/access_check_operator.proto

/* eslint-disable */

/** The operation for the access check, i.e. AND/OR */
export enum AccessCheckOperator {
  AND = 0,
  OR = 1,
  UNRECOGNIZED = -1,
}

export function accessCheckOperatorFromJSON(object: any): AccessCheckOperator {
  switch (object) {
    case 0:
    case "AND":
      return AccessCheckOperator.AND;
    case 1:
    case "OR":
      return AccessCheckOperator.OR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AccessCheckOperator.UNRECOGNIZED;
  }
}

export function accessCheckOperatorToJSON(object: AccessCheckOperator): string {
  switch (object) {
    case AccessCheckOperator.AND:
      return "AND";
    case AccessCheckOperator.OR:
      return "OR";
    case AccessCheckOperator.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
